module.exports = __webpack_public_path__ + "img/menuboard_teryiaki.8ac05e67.jpg";